import React from 'react'
import './Game.css'

function Game() {

    document.title = "Game";

  return (
    <div className="Game">
        <div className="game__content"> 
            <div className="game__g">
                G
            </div>
            <div className="game__m">
                LENN
            </div>
        </div>
    </div>
  )
}

export default Game